import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class CarteiraDeIntegradoresFiltrosService {

  constructor(private http: HttpClient) { }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, idVendedor) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if(idVendedor) {
      parametros.set('idVendedor', idVendedor);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CarteiraDeIntegradoresFiltro/ListaPag',
      {
        params: parametros
      });
  }

  consultarFiltro(filtroId) {
    return this.http.get<any>(globals.apiUrl + '/api/CarteiraDeIntegradoresFiltro/Buscar/' + filtroId);
  }

  salvarFiltro(filtro) {
    return this.http.post(globals.apiUrl + '/api/CarteiraDeIntegradoresFiltro/Salvar', filtro);
  }

  excluirFiltro(filtroId) {
    return this.http.delete(globals.apiUrl + '/api/CarteiraDeIntegradoresFiltro/Excluir/',{ params: new HttpParams().set('id', filtroId) });
  }
}
